import { Button } from '@/components/ui/button';

type CatalogPageNavProps = {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
};

export function CatalogPageNav({ page, totalPages, onPageChange }: CatalogPageNavProps) {
  if (totalPages <= 1) return null;
  return (
    <div className="mt-8 flex items-center justify-center gap-2">
      <Button
        variant="outline"
        className="bg-white"
        disabled={page <= 1}
        onClick={() => onPageChange(Math.max(1, page - 1))}
      >
        Предыдущая
      </Button>
      <span className="px-4 py-2 text-sm text-gray-600">
        Страница {page} из {totalPages}
      </span>
      <Button
        variant="outline"
        className="bg-white"
        disabled={page >= totalPages}
        onClick={() => onPageChange(Math.min(totalPages, page + 1))}
      >
        Следующая
      </Button>
    </div>
  );
}
